module.exports = __webpack_public_path__ + "img/stvrt-hradza.8e57be9d.jpg";